import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ACTION_MENU_CLASS_NAME = 'ActionMenu';
export const ACTION_MENU_CLASS_SLOTS = ['root', 'wrapper'] as const;

export type ActionMenuClassSlot = (typeof ACTION_MENU_CLASS_SLOTS)[number];

export interface ActionMenuClasses {
	/** Styles applied to the root element. */
	root: string;
	wrapper: string;
}

export const getActionMenuUtilityClass = (slot: string) =>
	generateUtilityClass('ActionMenu', slot);

export const actionMenuClasses: ActionMenuClasses = generateUtilityClasses(
	'ActionMenu',
	['root', 'wrapper'],
);

export default actionMenuClasses;
